import type {
  FindNewReviewQuery,
  FindNewReviewQueryVariables,
} from 'types/graphql'
import type { CellSuccessProps, CellFailureProps } from '@cedarjs/web'
import NewReview from '../NewReview/NewReview'
import { useDateStore } from "src/lib/store";
import "src/fragments/knackeries"
import { Alert, Card, Skeleton } from "@mui/material";
import { t } from "i18next";

export const beforeQuery = ({ idTank }) => {
  const date = useDateStore(state => state.getDateForGQL())

  return { variables: { date, idTank } }
}


export const QUERY = gql`
  query FindNewReviewQuery($date: Date, $idTank: Int!) {
    review(date:$date, idTank: $idTank){
      ...ReviewFragment
    }
    tank(id: $idTank) {
      id
      idSite
      idWater
      name
      lastBatchTransfer {
        batch {
          id
          name
        }
      }
    }
  }
`

export const Loading = ({ className }) => (
  <Card className={`p-5 m-2 h-96 grid grid-flow-row gap-4 grid-rows-4 ${className}`}>
    <Skeleton variant="text" height={40} className="mr-12" />
    <Skeleton variant="rounded" height={40} />
    <Skeleton variant="rounded" height={40} />
    <Skeleton variant="rounded" height={40} />
    <Skeleton variant="rounded" height={40} />
    <Skeleton variant="rounded" height={40} className="w-1/2 m-auto mt-8" />
  </Card>
)


export const isEmpty = ({ review }) => {
  return (!review || review?.isHarvested || review?.idRootBatch)
}
export const Empty = ({tank}) => {
  return <div>
    <NewReview
      tank={tank}
    />
  </div>
}

export const Failure = ({
  error,
}: CellFailureProps<FindNewReviewQueryVariables>) => (
  <div style={{ color: 'red' }}>Error: {error?.message}</div>
)

export const Success = ({ review, tank }: CellSuccessProps<FindNewReviewQuery, FindNewReviewQueryVariables>) => {
  return (
    <NewReview
      review={review}
      tank={tank}
    />
  )
}
